import React, { useEffect } from 'react';
import { func } from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import _keyBy from 'lodash/keyBy';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import { useConfigService, useStore } from '@thd-nucleus/experience-context';
import { fulfillmentApi, productsApi } from '../api/graphQL';
import { useProductDataStore } from '../store';
import { useDesignStore } from '../store/design/context';
import { pickPromoSkus, addPricingAndFulfillment, pickErrorDiff } from '../hooks/utils';
import { getLocalizerZipCode } from '../utils/fulfillment-utils';

const GraphDataOrchestrator = ({ setHydrated }) => {
  const fulfillmentBaseUrl = useConfigService('graphQL:fulfillmentBaseUrl');
  const graphBaseUrl = useConfigService('graphQL:baseUrl');
  const productsPerBatch = useConfigService('graphQL:productsPerBatch');
  const fulfillmentPerBatch = useConfigService('graphQL:fulfillmentPerBatch');
  const store = useStore();
  const { storeId = '8119' } = store;
  const zipCode = getLocalizerZipCode();
  const storedProductData = useProductDataStore((state) => state.productData);
  const fetchedSkus = useProductDataStore((state) => state.fetchedSkus);
  const appendProductData = useProductDataStore((state) => state.appendProductData);
  const appendFetchedSkus = useProductDataStore((state) => state.appendFetchedSkus);
  const productSkus = useDesignStore((state) => _map(state.design.products, (product) => product?.Sku));
  const cartSkus = useDesignStore((state) => _map(state.design.cart, (lineItem) => lineItem?.Sku));

  useEffect(() => {
    const fetchData = async (skus) => {
      if (!_isEmpty(skus)) {
        const response = await productsApi(graphBaseUrl, productsPerBatch, skus, zipCode);
        return response;
      }
      return [];
    };

    const getFulfillment = async (skus) => {
      if (!_isEmpty(skus)) {
        const response = await fulfillmentApi(fulfillmentBaseUrl, fulfillmentPerBatch, skus, storeId, zipCode);
        return response;
      }
      return [];
    };

    const resolver = async (productDataStore, skus) => {
      const diff = pickPromoSkus(productDataStore, skus);
      if (diff) {
        const needToFetch = _filter(diff, (itemId) => fetchedSkus.indexOf(itemId) === -1);
        if (needToFetch.length) {
          const productData = await fetchData(needToFetch);
          const fulfillmentData = await getFulfillment(needToFetch);
          const errorSkus = pickErrorDiff(needToFetch, _map(productData, 'itemId'));
          const productDataWithFulfillment = addPricingAndFulfillment(
            productData, _keyBy(fulfillmentData, 'itemId')
          );

          const additionalProductData = _keyBy(productDataWithFulfillment, 'itemId');
          appendProductData(additionalProductData);
          const allFetchedSkus = [...Object.keys(additionalProductData), ...errorSkus];
          appendFetchedSkus(allFetchedSkus);
        }
      }

      setHydrated({
        design: true,
        graph: true,
      });
    };

    if (!_isEmpty(storedProductData)) {
      resolver(storedProductData, [...productSkus, ...cartSkus]);
    }
  }, [storedProductData, productSkus.length, cartSkus.length]);

  return (<div />);
};

GraphDataOrchestrator.propTypes = {
  setHydrated: func.isRequired
};

export default GraphDataOrchestrator;
